"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetAutoflowByIdResponse () {
        return GetAutoflowByIdResponse;
    },
    get GetAutoflowsResponse () {
        return GetAutoflowsResponse;
    },
    get PatchAutoflowResponse () {
        return PatchAutoflowResponse;
    },
    get PostAutoflowPreviewResponse () {
        return PostAutoflowPreviewResponse;
    },
    get PostAutoflowResponse () {
        return PostAutoflowResponse;
    }
});
const _zod = require("zod");
const _autoflow = require("./autoflow");
const _task = require("./tasks/task");
const GetAutoflowsResponse = _autoflow.AutoflowModel.array();
const GetAutoflowByIdResponse = _autoflow.AutoflowModel.nullable();
const PostAutoflowResponse = _autoflow.AutoflowModel;
const PatchAutoflowResponse = _autoflow.AutoflowModel;
const PostAutoflowPreviewResponse = _zod.z.object({
    tasks: _task.AutoflowTaskResponse.array()
});
